import { apiGet, apiBasic } from "./requests";
export const getOwnerOnboarding = () => apiGet("owner-onboarding");
export const saveOwnerOnboarding = (data) =>
  apiBasic(data, "owner-onboarding", "patch");
